import store from "@/config/vuex/store";

export default [
    {
        path: "/carros",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "carrosRead",
                component: () => import('@/pages/Carro/CarroRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "carrosCreate",
                component: () => import('@/pages/Carro/CarroCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "carrosUpdate",
                component: () => import('@/pages/Carro/CarroUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "motoristas/:id",
                name: "carrosReadMotorista",
                component: () => import('@/pages/Carro/CarroReadMotorista'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

